import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import Base64SizeCalculator from '../components/Base64SizeCalculator';
import FaqSection from '../components/Faq';
import { PageHero } from '../components/InfoSections';
import { softwareApplicationSchema, faqPageSchema, breadcrumbSchema, Faq } from '../lib/schema';

const FAQS: Faq[] = [
  { q: 'Why does Base64 make data bigger?', a: 'Base64 represents every 3 bytes of input as 4 output characters, so the encoded size is always about 4/3 (roughly 33%) larger than the original.' },
  { q: 'What is the exact formula for Base64 output size?', a: 'ceil(inputBytes / 3) * 4. For example, 10 bytes becomes ceil(10/3)*4 = 4*4 = 16 characters.' },
  { q: 'Does the 33% overhead apply to all variants?', a: 'Standard and URL-safe Base64 have the same core overhead. URL-safe Base64 without padding is very slightly smaller since it drops the trailing "=" characters.' },
  { q: 'Should I worry about Base64 overhead for large files?', a: 'For large binary files (images, videos, attachments), the extra ~33% can matter for bandwidth and storage — consider whether you actually need text-safe encoding or can transmit raw bytes instead.' },
];

export default function Base64SizeCalculatorPage() {
  return (
    <>
      <Seo
        title="Base64 Size Calculator — Estimate Encoded Output Size | EasyBase64"
        description="Calculate how large your data becomes after Base64 encoding. Paste text or enter a byte count to see the exact output size and overhead percentage."
        path="/base64-size-calculator"
        jsonLd={[
          softwareApplicationSchema({ name: 'Base64 Size Calculator', description: 'Calculate Base64 encoded output size from text or a byte count.', path: '/base64-size-calculator' }),
          faqPageSchema(FAQS),
          breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Base64 Size Calculator', path: '/base64-size-calculator' }]),
        ]}
      />
      <PageHero
        title="Base64 Size Calculator"
        subtitle={<>See exactly how much bigger your data gets after Base64 encoding. Curious why? Read <Link to="/base64-file-size-overhead" className="underline">why Base64 makes files ~33% larger</Link>.</>}
      />
      <div className="mb-12 max-w-3xl mx-auto">
        <Base64SizeCalculator />
      </div>
      <FaqSection title="Base64 Size Calculator — FAQ" faqs={FAQS} />
    </>
  );
}
